export const NAVIGATION_ID = 'navigation';
